/**
 * Верхние плашки выбора секций RW: обёртка div; слева кнопка, стилизованная как название (запуск теста).
 * PR-D4-031: verbatim from MadCrab_V technical/src/HubDatabaseStats.jsx
 */
// @ts-nocheck
import { categories } from './lib/rwCategories.js';

/**
 * Одна строка: слева подпись и кнопка «Секция» (запуск теста).
 * @param {{
 *   title: string;
 *   skillKey: string;
 *   disabled: boolean;
 *   onStartTest: () => void;
 * }} p
 */
function HubCategoryCard({ title, skillKey, disabled, onStartTest }) {
  const skillEnc = encodeURIComponent(skillKey);
  const href = `?domain=rw&skill=${skillEnc}`;
  void href;

  return (
    <div className="app-hub-section--split">
      <div className="app-hub-section__left">
        <button
          type="button"
          className="app-hub-category-btn w-full"
          onClick={onStartTest}
          disabled={disabled}
        >
          {title}
        </button>
      </div>
    </div>
  );
}

/**
 * @param {{
 *   rwDifficulty: string;
 *   savedSession: unknown;
 *   beginSectionTest: (sectionKey: string, sectionTitle: string, difficulty: string) => void;
 * }} p
 */
export function HubRwCategoryCards({ rwDifficulty, savedSession, beginSectionTest }) {
  const disabled = !!savedSession;
  return (
    <div className="app-hub-section-grid">
      {Object.entries(categories).map(([title, key]) => (
        <HubCategoryCard
          key={key}
          title={title}
          skillKey={key}
          disabled={disabled}
          onStartTest={() => beginSectionTest(key, title, rwDifficulty)}
        />
      ))}
    </div>
  );
}
